import React, { useState, useContext, useEffect } from 'react'
import '../Dashboard/Dashboard.css'
import * as Yup from 'yup'
import {
    mapData,
    dateFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import Layout from '@/product/components/templates/Layout'
import ReportComponent from '@/product/views/Report/ReportComponent'
import SettingContext from '@/product/context/setting/settingContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { useTranslation } from 'react-i18next'

const ReportManagement = () => {
    const [state, setState] = useState({})
    const settingcontext = useContext(SettingContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { t } = useTranslation()
    const [locationDropDown, setLocationDropdown] = useState([])
    const [categoryDropDown, setCategoryDropdown] = useState([])
    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const {
        configVariables,
        alldata_all_dropdown,
        setLoginModal,
        allLocations,
        allCategory,
    } = customCommonContext

    const additionalfieldUpdate = (payload) => {
        setState(payload)
    }
    const [tableBody, setTableBody] = useState([])
    const [isSelected, setIsSelected] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [auctionFilters, setAuctionFilter] = useState([])

    const allSearchOptions = [
        { id: 'within', description: 'Within' },
        { id: 'customSelection', description: 'Custom Selection' },
    ]

    useEffect(() => {
        if (allLocations) {
            let data = []
            if (allLocations?.length) {
                data = allLocations?.map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.id
                    return busCategoryChanged
                })
            }
            setLocationDropdown(data)
        }
    }, [allLocations])

    useEffect(() => {
        if (allCategory) {
            let data = allCategory
                .filter(
                    (maincat) => maincat.active === 1 && maincat.level === 0
                )
                .map((maincat) => {
                    let categoryChanged = {}
                    categoryChanged.show = maincat.description
                    categoryChanged.value = maincat.id
                    return categoryChanged
                })

            setCategoryDropdown(data)
        }
    }, [allCategory])

    const handleDynamicSelect = (id, field) => {
        setTableBody([])
        if (field === 'closed_auction_completion_report') {
            setIsSelected(false)
            setIsLoading(true)

            let initialValues = {
                page: 1,
                limit: 1000,
                order: 'asc',
                orderby: 'df.show_order',
                primaryTable: 'dynamic_fields',
                filters: {
                    label: {
                        value: '',
                        type: 'like',
                        field: 'df.label',
                    },
                    view_page: {
                        value: '',
                        type: 'in',
                        field: 'df.view_page',
                    },
                    active: {
                        value: 1,
                        type: 'in',
                        field: 'df.active',
                    },
                },
            }
            searchTableFetch(initialValues, field)
        } else {
            setIsSelected(true)
        }
    }

    const validation = Yup.object({
        order: Yup.string().required('Required!'),
        action: Yup.string().required('Required!'),
        report: Yup.string().required('Required!'),
        search: Yup.string().required('Required!'),
        start_date: Yup.date(),
        end_date: Yup.date().min(
            Yup.ref('start_date'),
            'Should be greater than from date'
        ),
        template_name: Yup.string().when(['template'], {
            is: true,
            then: Yup.string().required('Required'),
        }),
    })

    const dynamicFieldAdd = (item, field) => {
        let fieldSeprate = item.map((el) => {
            {
                if (el?.view_page == 1) {
                    el.field = 'projects_' + el.name
                } else if (el?.view_page == 2) {
                    el.field = el.name
                } else {
                    el.field = 'users_' + el.name
                }

                el.group = [field]
                return el
            }
        })
        let userFiled = fieldSeprate.filter(
            (el) =>
                el.view_page == 3 &&
                el.name !== 'password' &&
                el.name !== 'confirm_password' &&
                el.name !== 'avatar' &&
                el.name !== 'uploadimages' &&
                el.name !== 'profile_image'
        )
        let projectField = fieldSeprate.filter(
            (el) =>
                el.view_page == 1 &&
                el.name !== 'password' &&
                el.name !== 'confirm_password' &&
                el.name !== 'avatar' &&
                el.name !== 'uploadimages' &&
                el.name !== 'profile_image'
        )
        let AuctionsField = fieldSeprate.filter(
            (el) =>
                el.view_page == 2 &&
                el.name !== 'password' &&
                el.name !== 'confirm_password' &&
                el.name !== 'avatar' &&
                el.name !== 'uploadimages' &&
                el.name !== 'profile_image'
        )

        return [
            {
                title: 'User Field',
                formFields: [
                    {
                        id: 19,
                        view_page: '1',
                        label: 'User ID',
                        type: 'text',
                        field: 'users_id',
                        sort: 1,
                        sort_field: 'id',
                        show_order: 0,
                        table_search: 0,
                        folder: null,
                        is_deletable: 0,
                        active: 1,
                        filter_type: 'select type',
                        is_default: 0,
                        class: null,
                        diff_name: 0,
                        diff_sort: 0,
                    },
                    ...userFiled,
                ],
            },
            {
                title: 'Project Field',
                formFields: [
                    {
                        id: 19,
                        view_page: '1',
                        label: 'Project ID',
                        type: 'text',
                        field: 'projects_id',
                        name: 'projects_id',
                        sort: 1,
                        sort_field: 'p.id',
                        show_order: 0,
                        table_search: 0,
                        folder: null,
                        is_deletable: 0,
                        active: 1,
                        filter_type: 'select type',
                        is_default: 0,
                        class: null,
                        diff_name: 0,
                        diff_sort: 0,
                    },

                    ...projectField,
                ],
            },
            {
                title: 'Auctions Field',
                formFields: [
                    {
                        id: 19,
                        view_page: '1',
                        label: 'Auction ID',
                        type: 'text',
                        field: 'id',
                        sort: 1,
                        sort_field: 'ac.id',
                        show_order: 0,
                        table_search: 0,
                        folder: null,
                        is_deletable: 0,
                        active: 1,
                        filter_type: 'select type',
                        is_default: 0,
                        class: null,
                        diff_name: 0,
                        diff_sort: 0,
                    },

                    ...AuctionsField,
                ],
            },
        ]
    }

    const dynamicFieldFilter = (item, field) => {
        let fieldSeprate = item.map((el) => {
            {
                if (el?.view_page == 1) {
                    el.field = 'p.' + el.name
                    el.filter = true
                } else if (el?.view_page == 2) {
                    el.field = 'ac.' + el.name
                    el.filter = true
                } else {
                    el.field = 'u.' + el.name
                    el.filter = true
                }
                if (el.name === 'location') {
                    el.options = locationDropDown
                }
                if (el.name === 'category') {
                    el.options = categoryDropDown
                    el.field = 'it.category'
                }
                el.group = [field]
                return el
            }
        })

        let dataFilter = fieldSeprate.filter(
            (el) =>
                el.name !== 'password' &&
                el.name !== 'confirm_password' &&
                el.name !== 'avatar' &&
                el.name !== 'uploadimages' &&
                el.name !== 'profile_image' &&
                el.name !== 'auction_category' &&
                el.name !== 'date_added' &&
                el.name !== 'date_closed' &&
                el.name !== 'local_pickup_check' &&
                el.name !== 'buynow' &&
                el.name !== 'auction' &&
                el.name !== 'featured' &&
                el.name !== 'zip' &&
                el.name !== 'desc_proc' &&
                el.name !== 'isassembled' &&
                el.name !== 'ispacked' &&
                el.name !== 'weight_unit' &&
                el.name !== 'ship_service' &&
                el.name !== 'local_pickup_appt_per_slot' &&
                el.name !== 'local_pickup_slot_timeframe' &&
                el.name !== 'local_pickup_end_hour' &&
                el.name !== 'weight_value' &&
                el.name !== 'timed_auction' &&
                el.name !== 'dimension_length' &&
                el.name !== 'ending_mins' &&
                el.name !== 'local_pickup_dates'
        )

        return [
            {
                id: 19,
                view_page: '1',
                label: 'User ID',
                name: 'userid',
                type: 'text',
                field: 'u.id',
                sort: 1,
                sort_field: 'id',
                show_order: 0,
                table_search: 0,
                folder: null,
                is_deletable: 0,
                active: 1,
                filter_type: 'select type',
                is_default: 0,
                class: null,
                diff_name: 0,
                diff_sort: 0,
                filter: true,
            },
            {
                id: 20,
                view_page: '1',
                label: 'Projects ID',
                type: 'text',
                field: 'p.id',
                name: 'projectsid',
                sort: 1,
                sort_field: 'p.id',
                show_order: 0,
                table_search: 0,
                folder: null,
                is_deletable: 0,
                active: 1,
                filter_type: 'select type',
                is_default: 0,
                class: null,
                diff_name: 0,
                diff_sort: 0,
                filter: true,
            },
            {
                id: 21,
                view_page: '1',
                label: 'Auction ID',
                type: 'number',
                field: 'ac.id',
                name: 'auctionid',
                sort: 1,
                sort_field: 'ac.id',
                show_order: 0,
                table_search: 0,
                folder: null,
                is_deletable: 0,
                filter: true,
                active: 1,
                filter_type: 'select type',
                is_default: 0,
                class: null,
                diff_name: 0,
                diff_sort: 0,
            },
            ...dataFilter,
        ]
    }

    useEffect(() => {
        if (search_fetch_data) {
            let field = search_fetch_data.from
            let dynamicuData = search_fetch_data.records
                ? search_fetch_data.records
                : []

            let tableBodyData = JSON.parse(JSON.stringify(dynamicuData))
            setTableBody(dynamicFieldAdd(tableBodyData, field))
            let dynamicFilter = JSON.parse(JSON.stringify(dynamicuData))
            setAuctionFilter(dynamicFieldFilter(dynamicFilter, field))
            setIsLoading(false)
        }
    }, [search_fetch_data])

    const initialValues = {
        action: 'display',
        order: 'asc',
        orderby: '',
        search: 'within',
        report: 'active_user_management',
        within: 'day',
        page: 1,
        limit: 20,
        start_date: dateFormatFunction(new Date()),
        end_date: dateFormatFunction(new Date()),
        limit_results: '',
        searchterm: '',
        fields: [],
        report_heading: '',
        export_file_name: '',
        filters: {
            auctionid: {
                value: '',
                type: 'in',
                field: 'ac.id',
            },
            userid: {
                value: '',
                type: 'in',
                field: 'u.id',
            },
            projectsid: {
                value: '',
                type: 'in',
                field: 'u.id',
            },
            location: {
                value: '',
                type: 'in',
                field: 'p.location_id',
            },
            category: {
                value: '',
                type: 'in',
                field: 'it.category',
            },
        },
    }

    const searchInfo = {
        data: [
            {
                label: 'Search Term',
                placeholder: 'Enter Search Term',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
            },
        ],
    }

    const auctionFilter = {
        data: auctionFilters,
        // data: [
        //     {
        //         label: 'User ID',
        //         class: 'col-md-4 col-sm-6 col-12',
        //         type: 'number',
        //         filter: true,
        //         name: 'userid',
        //         field: 'u.id',
        //         id: 1,
        //     },
        //     {
        //         label: 'Projects ID',
        //         class: 'col-md-4 col-sm-6 col-12',
        //         type: 'number',
        //         filter: true,
        //         name: 'projectsid',
        //         field: 'p.id',
        //         id: 2,
        //     },
        //     {
        //         label: 'Auction ID',
        //         class: 'col-md-4 col-sm-6 col-12',
        //         type: 'number',
        //         filter: true,
        //         name: 'auctionid',
        //         field: 'ac.id',
        //         id: 3,
        //     },
        //     {
        //         label: 'Location',
        //         class: 'col-md-4 col-sm-6 col-12',
        //         type: 'select',
        //         filter: true,
        //         options: locationDropDown,
        //         name: 'location',
        //         field: 'p.location_id',
        //         id: 4,
        //     },
        //     {
        //         label: 'category',
        //         class: 'col-md-4 col-sm-6 col-12',
        //         type: 'select',
        //         filter: true,
        //         options: categoryDropDown,
        //         name: 'category',
        //         field: 'it.category',
        //         id: 5,
        //     },
        // ],
    }

    const report = {
        data: [
            {
                label: 'Report',
                placeholder: 'Enter Report',
                class: 'col-12',
                type: 'select',
                groupoptions: [
                    {
                        head: 'Customer management',
                        options: [
                            { value: 'active_user_management', show: 'Active' },
                            {
                                value: 'deactivate_user_management',
                                show: 'Deactive',
                            },
                            {
                                value: 'unverified_user_management',
                                show: 'Unverified',
                            },
                        ],
                    },
                    {
                        head: 'Product management',
                        options: [
                            { value: 'open_product_management', show: 'Open' },
                            {
                                value: 'ending_product_management',
                                show: 'Ending',
                            },
                            {
                                value: 'closed_product_management',
                                show: 'Closed',
                            },
                            { value: 'sold_product_management', show: 'Sold' },
                        ],
                    },
                    {
                        head: 'Auction management',
                        options: [
                            { value: 'open_auction_management', show: 'Open' },
                            {
                                value: 'ending_auction_management',
                                show: 'Ending',
                            },
                            {
                                value: 'closed_auction_management',
                                show: 'Closed',
                            },
                            { value: 'sold_auction_management', show: 'Sold' },
                        ],
                    },
                    {
                        head: 'Sold Order management',
                        options: [{ value: 'sold_order', show: 'Sold' }],
                    },
                    {
                        head: 'Invoice management',
                        options: [
                            { value: 'paid_invoice_management', show: 'Paid' },
                            {
                                value: 'unpaid_invoice_management',
                                show: 'Unpaid',
                            },
                        ],
                    },
                    {
                        head: 'Employee management',
                        options: [
                            {
                                value: 'employee_list',
                                show: 'Employee Details',
                            },
                        ],
                    },
                    {
                        head: 'Wallet management',
                        options: [
                            {
                                value: 'deposit_balance',
                                show: 'Wallet Details',
                            },
                        ],
                    },
                    {
                        head: 'Transaction management',
                        options: [
                            {
                                value: 'transaction_list',
                                show: 'Transaction Details',
                            },
                        ],
                    },
                    {
                        head: 'all Paid Product Report',
                        options: [
                            {
                                value: 'all_paid_reports',
                                show: 'All Paid Product Details',
                            },
                        ],
                    },
                    {
                        head: 'All dynamic fields ',
                        options: [
                            {
                                value: 'closed_auction_completion_report',
                                show: 'Auctions',
                            },
                        ],
                    },
                ],
                name: 'report',
            },
        ],
    }

    const limitResult = {
        data: [
            {
                label: 'Limit results',
                placeholder: 'Enter Limit results',
                type: 'number',
                class: 'col-12 ',
                size: 'small',
                name: 'limit_results',
            },
        ],
    }

    let fieldsToShow = []

    fieldsToShow = [
        {
            field: 'id',
            label: 'Customer ID',
            sort: true,
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'user_fullname',
            label: 'Customer Name',
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'email',
            label: 'Customer Email',
            sort: true,
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'phone',
            label: 'Phone Number',
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'created_at',
            label: 'Created Date',
            sort: true,
            type: 'datetime',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'last_login',
            label: 'Last Login',
            sort: true,
            type: 'datetime',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'status',
            label: 'Status',
            type: 'capitalize',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'deposit_amount',
            label: 'Wallet Balance',
            type: 'price',
            group: ['deposit_balance'],
        },
        {
            field: 'id',
            label: 'ID',
            sort: true,
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
            ],
        },
        {
            field: 'title',
            label: 'Title',
            sort: true,
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'date_added',
            label: 'Starting Date',
            sort: true,
            type: 'datetime',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
            ],
        },
        {
            field: 'date_closed',
            label: 'End Date',
            sort: true,
            type: 'datetime',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
            ],
        },
        {
            field: 'auctionid',
            label: 'Auction ID',
            sort: true,
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'auction_title',
            label: 'Auction Title',
            sort: true,
            type: 'capitalize',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
                'all_paid_reports',
            ],
        },
        {
            field: 'auction_description',
            label: 'Auction Description',
            sort: true,
            type: 'capitalize',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'auction_date_added',
            label: 'Auction Starting Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'auction_date_closed',
            label: 'Auction End Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'auction_status',
            label: 'Auction Status',
            sort: true,
            type: 'capitalize',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_id',
            label: 'Lot ID',
            sort: true,
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_title',
            label: 'Lot Title',
            sort: true,
            type: 'capitalize',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_date_added',
            label: 'Lot Starting Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_date_closed',
            label: 'Lot End Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'sprice',
            label: 'Starting Price',
            type: 'price',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'bprice',
            label: 'Buynow Price',
            type: 'price',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'qty',
            label: 'Total Quantity',
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'sold',
            label: 'Sold Quantity',
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'buynowamount',
            label: 'Sold Price',
            type: 'price',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'wprice',
            label: 'Current Price',
            sort: true,
            type: 'price',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'market_status',
            label: 'Status',
            sort: true,
            type: 'capitalize',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'totalbids',
            label: 'No. of Bids',
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'numDiffBidders',
            label: 'No. of Different Bidders',
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'winnerName',
            label: 'Buyer Name',
            type: '',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'winemail',
            label: 'Winner Email',
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
            ],
        },
        {
            field: 'winnerEmail',
            label: 'Winner Email',
            type: 'capitalize',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'winnerCompany',
            label: 'Buyer Company',
            type: 'capitalize',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'buynowemail',
            label: 'Buyer Email',
            type: '',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'common_invoice',
            label: 'Invoice ID',
            sort: true,
            type: '',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
                'transaction_list',
            ],
        },
        {
            field: 'paid_date',
            label: 'Paid Date',
            sort: true,
            type: 'datetime',
            group: ['sold_product_management', 'all_paid_reports'],
        },
        {
            field: 'shipping_amount',
            label: 'Shipping Price',
            sort: true,
            type: 'price',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'total_invoice',
            label: 'Total Price',
            sort: true,
            type: 'price',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'date_added',
            label: 'Sold Date',
            sort: true,
            type: 'date',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'paid_date',
            label: 'Paid Date',
            sort: true,
            type: 'date',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'project_id',
            label: 'Product ID',
            sort: true,
            type: '',
            group: ['sold_order'],
        },
        {
            field: 'sold_qty',
            label: 'Purchased Qty',
            sort: true,
            type: '',
            group: [
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'date_added',
            label: 'Sale Date',
            sort: true,
            type: 'date',
            group: ['sold_order'],
        },
        {
            field: 'paid',
            label: 'Paid Status',
            sort: true,
            type: 'paid_status',
            group: [
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'emp_firstname',
            label: 'First Name',
            sort: true,
            type: 'capitalize',
            group: ['employee_list'],
        },
        {
            field: 'emp_lastname',
            label: 'Last Name',
            sort: true,
            type: 'capitalize',
            group: ['employee_list'],
        },
        {
            field: 'emp_email',
            label: 'Email',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_phone',
            label: 'Phone Number',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_address1',
            label: 'Address',
            sort: true,
            type: 'capitalize',
            group: ['employee_list'],
        },
        {
            field: 'emp_city',
            label: 'City',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_zip',
            label: 'Zip Code',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_state',
            label: 'State',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_country',
            label: 'Country',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_type',
            label: 'Employee Type',
            sort: true,
            type: 'em_type',
            group: ['employee_list'],
        },
        {
            field: 'trans_id',
            label: 'Transaction ID',
            sort: true,
            type: '',
            group: ['transaction_list'],
        },
        {
            field: 'amount',
            label: 'Amount',
            sort: true,
            type: 'price',
            group: ['transaction_list'],
        },
        {
            field: 'user_fullname',
            label: 'Buyer Name',
            sort: true,
            type: 'capitalize',
            group: ['transaction_list'],
        },
        {
            field: 'email',
            label: 'Buyer Email',
            sort: true,
            type: '',
            group: ['transaction_list'],
        },
        {
            field: 'payment_method',
            label: 'Payment Type',
            sort: true,
            type: 'capitalize',
            group: ['transaction_list'],
        },
        {
            field: 'card_type',
            label: 'Gateway',
            sort: true,
            type: 'capitalize',
            group: ['transaction_list'],
        },
        {
            field: 'created_at',
            label: 'Paid Date',
            sort: true,
            type: 'datetime',
            group: ['transaction_list'],
        },
        {
            field: 'totalbids',
            label: 'No. of Bids',
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_amount',
            label: 'Bid Deposit Amount',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_status',
            label: 'Bid Deposit Status',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_date_added',
            label: 'Bid Deposit Date Added',
            sort: true,
            type: 'datetime',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_gateway',
            label: 'Bid Deposit Gate Way',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_refunded',
            label: 'Bid refended',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
    ]

    return (
        <Layout>
            <ReportComponent
                orderSort={global?.orderSort ? global.orderSort : false}
                formFields={isSelected ? fieldsToShow : tableBody}
                loading={isLoading}
                report={report}
                allSearchOptions={allSearchOptions}
                validationSchema={validation}
                limitResult={limitResult}
                dynamicSelect={handleDynamicSelect}
                initialValues={initialValues}
                additionalfieldUpdate={additionalfieldUpdate}
                searchInfo={searchInfo}
                auctionFilter={auctionFilter}
                customLabel="Customize your report using a wide variety of date range options."
                SubmitBtnLabel="Generate Report"
                specific_seller={true}
            />
            {/* <ReportComponent
                orderSort={global?.orderSort ? global.orderSort : false}
                formFields={isSelected ? fieldsToShow : tableBody}
                loading={isLoading}
                report={report}
                allSearchOptions={allSearchOptions}
                validationSchema={validation}
                limitResult={limitResult}
                initialValues={initialValues}
                dynamicSelect={handleDynamicSelect}
                additionalfieldUpdate={additionalfieldUpdate}
                searchInfo={searchInfo}
                customLabel="Customize your report using a wide variety of date range options."
                SubmitBtnLabel="Generate Report"
            /> */}
        </Layout>
    )
}

export default ReportManagement
